import { IBaccaratWinType } from "./games/Baccarat";
import { IDragonTigerWinType } from "./commonMobile";

export type genericCards = "x" | "As" | "2s" | "3s" | "4s" | "5s" | "6s" | "7s" | "8s" | "9s" | "Js" | "Qs" | "Ks" | "Ad" | "2d" | "3d" | "4d" | "5d" | "6d" | "7d" | "8d" | "9d" | "Jd" | "Qd" | "Kd" | "Ac" | "2c" | "3c" | "4c" | "5c" | "6c" | "7c" | "8c" | "9c" | "Jc" | "Qc" | "Kc" | "Ah" | "2h" | "3h" | "4h" | "5h" | "6h" | "7h" | "8h" | "9h" | "Jh" | "Qh" | "Kh";

// function generateCards() {
// 	return ["s", "d", "c", "h"].map(suit => "A23456789JQK".split("").map(val => `${val}${suit}`).join(",")).join(",").split(",");
// }

const defaultBaccaratResult: IBaccaratWinType = { player: "x-x-x", playerValue: 0, banker: "x-x-x", bankerValue: 0 };
// const defaultBaccaratResult = {player: "6h-6d-6c", playerValue: 8, banker: "6s-7d-7c", bankerValue: 0, win: "banker"};

const defaultDragonTigerResult: IDragonTigerWinType = { dragon: "x", dragonValue: 0, tiger: "x", tigerValue: 0 };
// const defaultDragonTigerResult = {dragon: "4h", dragonValue: 4, tiger: "5h", tigerValue: 5}; //, win: ""};

const defaultNiuNiuResult = { pcode: "m24", firstCard: "x", banker: "x-x-x-x-x", player1: "x-x-x-x-x", player2: "x-x-x-x-x", player3: "x-x-x-x-x", valueBanker: "nobull", valuePlayer1: "nobull", valuePlayer2: "nobull", valuePlayer3: "nobull", winners: "", submit: false, periode: 0, gameSet: 0 };
// const defaultNiuNiuResult = { "pcode": "m24", "firstCard": "9c", "firstSpot": "banker", "banker": "Qc-5h-6s-5s-7d", "player1": "5d-2h-Ts-Ks-Ah", "player2": "5c-Kd-7s-4h-4s", "player3": "6d-Kh-6c-x-x", "valueBanker": "bull3", "valuePlayer1": "nobull", "valuePlayer2": "nobull", "valuePlayer3": "nobull", "winners": null, "submit": false, "periode": 150, "gameSet": 69261 };

const defaultShioFightResult = { gamekey: 0, win: "", di: "x", tian: "x", value: 0, periode: 0 };
// const defaultShioFightResult = { "pcode": "m27", "di": "snake", "tian": "pig", "value": "7", "win": "tian", "submit": true, "periode": 3, "gameSet": 114 };

export {
	defaultBaccaratResult,
	defaultDragonTigerResult,
	defaultNiuNiuResult,
	defaultShioFightResult
}